<template>
  <v-layout row align-center background-color="white">
    <v-select color="primary" flat solo hide-details background-color="transparent" readonly :items="['[','(']"
      v-model="lowSymbol" style="max-width: 20px" append-icon=""></v-select>
    <v-text-field flat solo hide-details background-color="transparent" readonly v-model="range.lower" label="下限"
      style="max-width: 100px;margin-left: 0px;"></v-text-field>
    <v-select flat solo hide-details background-color="transparent" readonly color="error" append-icon="" flat readonly
      :items="[',','~','——']" v-model="rangeSymbol" style="max-width: 50px">
    </v-select>
    <v-text-field flat solo hide-details background-color="transparent" readonly v-model="range.upper" label="上限"
      style="max-width: 100px;text-align: right;"></v-text-field>
    <v-select flat solo hide-details background-color="transparent" readonly append-icon="" :items="[']',')']"
      v-model="upperSymbol" style="max-width: 20px;"></v-select>
  </v-layout>
</template>

<style scoped>

</style>

<script>
  import RangeCell from "./rangeCell.ts";
  export default RangeCell;
</script>